export function createCesiumDashPattern(dashPattern: string): number {
    if (!/^[- ]{1,32}$/.test(dashPattern)) {
        throw new Error("Invalid dash pattern, only dash (-) and space ( ) characters are allowed. Maximum length is 32 characters.");
    }

    const dashPatternBinary = dashPattern.replace(/ /g, "0").replace(/-/g, "1");

    return parseInt(dashPatternBinary, 2);
}
